// extracted by mini-css-extract-plugin
export default {"loginContainer":"loginContainer_dLWrO","tips":"tips_ERPJU"};